import get from 'lodash.get';
import pickBy from 'lodash.pickby';
import lowerCase from 'lodash.lowercase';

export default class Dealership {
  constructor(dealership) {
    const propsToKeep = [
      'id',
      'name',
      'logo_uri',
      'dealership_type',
      'active',
      'member_type',
      'address',
      'location',
      'zip_code',
      'sales_rep',
      'billing_contact_lob',
      'is_primary_contact',
    ];

    // If we're coming in from client storage (localStorage, indexddb)
    // then we need to check the nested prop. If we're coming in from
    // an API request, we use the object as it is. -ETC
    let objectToPickFrom = dealership;
    if (Object.prototype.hasOwnProperty.call(dealership, 'dealership')) {
      objectToPickFrom = dealership.dealership;
    }

    this.dealership = pickBy(objectToPickFrom, (value, key) => propsToKeep.includes(key));
    // use setters to set appropriate types - ETC
    this.dealership.id = objectToPickFrom.id;
    this.dealership.dealershipType = objectToPickFrom.dealership_type;
    this.dealership.memberType = objectToPickFrom.member_type;
  }

  get id() {
    return get(this.dealership, 'id', 0);
  }

  set id(id) {
    this.dealership.id = Number.parseInt(id, 10);
  }

  get name() {
    return get(this.dealership, 'name', 'Unknown');
  }

  get active() {
    return get(this.dealership, 'active', false);
  }

  get dealershipType() {
    return get(this.dealership, 'dealership_type', 0);
  }

  set dealershipType(dealershipType) {
    this.dealership.dealership_type = Number.parseInt(dealershipType, 10);
  }

  get logoUri() {
    return get(this.dealership, 'logo_uri', null);
  }

  get memberType() {
    return get(this.dealership, 'member_type', '');
  }

  set memberType(memberType) {
    this.dealership.member_type = lowerCase(memberType);
  }

  get address() {
    return get(this.dealership, 'address', '');
  }

  get city() {
    return get(this.dealership.location, 'city', '');
  }

  get region() {
    return get(this.dealership.location, 'region', '');
  }

  get zipCode() {
    return get(this.dealership, 'zip_code', '');
  }

  get addressDisplay() {
    return [
      this.address,
      `${this.city ? `${this.city},` : ''}`,
      this.region,
      this.zipCode,
    ].join(' ');
  }

  get salesRep() {
    return get(this.dealership, 'sales_rep', null);
  }

  get isPrimaryContact() {
    return get(this.dealership, 'is_primary_contact', false);
  }

  get billingContactLob() {
    return get(this.dealership, 'billing_contact_lob', []);
  }
}
